import CompanySN from 'af-components/SideNav/CompanySN';
import EmptySN from 'af-components/SideNav/EmptySN';
import OrganizationSN from 'af-components/SideNav/OrganizationSN';
import PlatformAdminSN from 'af-components/SideNav/PlatformAdminSN';

export const Company = CompanySN;
export const Empty = EmptySN;
export const Organization = OrganizationSN;
export const PlatformAdmin = PlatformAdminSN;
